/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { UPDATE_PAYOUT_STATUS } from '@pages/PayoutDetailPage/apis/graphql';

import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutDetailPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';

import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';
import { usePolicyId } from '@pages/PayoutDetailPage/provider';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface UpdatePayoutProps {
  paymentStatus: string;
  amount: string;
  comment: string;
  receipt?: any;
}

const lookup = require('country-code-lookup');

export interface IUpdatePayoutDetailMethods extends IPluginMethodMap {
  getUpdatePayoutDetailProps(args: any): Promise<any>;
}

export class UpdatePayoutDetailPlugin implements IAgentPlugin {
  readonly methods: IUpdatePayoutDetailMethods;

  constructor() {
    this.methods = {
      getUpdatePayoutDetailProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    return await this.getUpdatePayoutDetail(args);
  }

  private async getUpdatePayoutDetail(args: any) {
    const { userVid, policyNumber, payoutId } = usePolicyId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .mutation(UPDATE_PAYOUT_STATUS, {
          input: {
            ...args,
            paymentStatus: 'FULLY_PAID',
            payoutId: payoutId,
            amount: parseFloat(args?.amount),
            receipt: Array.isArray(args?.receipt)
              ? args?.receipt[0]?.base64
              : null,
          },
        })
        .toPromise();
      if (res?.data) {
        return res?.data?.updatePayoutStatus;
      }
    } catch (err: any) {
      console.log(`Sign In user error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
